import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import useFirestoreData from '../hooks/useFirestoreData';
import { searchSongsByTitle } from '../services/songService';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SearchResultsPage = () => {
    const q = useQuery();
    const term = q.get('q') || '';
    const navigate = useNavigate();

    const { data: liveUsers, loading: usersLoading } = useFirestoreData('users');
    const [songResults, setSongResults] = useState([]);
    const [active, setActive] = useState('people');

    useEffect(() => {
        const run = async () => {
            if (!term.trim()) {
                setSongResults([]);
                return;
            }
            try {
                const songs = await searchSongsByTitle(term);
                setSongResults(songs);
            } catch (err) {
                console.error('search results songs', err);
            }
        };
        run();
        return () => {};
    }, [term]);

    const people = (liveUsers || []).filter(u => {
        const name = (u.name || u.displayName || u.fullName || '').toLowerCase();
        return name.includes((term || '').toLowerCase());
    });

    return (
        <div style={{ padding: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                <button onClick={() => navigate(-1)} style={{ marginRight: 8 }}>Back</button>
                <h3>Search results for "{term}"</h3>
            </div>

            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                <button onClick={() => setActive('people')} aria-pressed={active === 'people'}>People ({people.length})</button>
                <button onClick={() => setActive('songs')} aria-pressed={active === 'songs'}>Songs ({songResults.length})</button>
            </div>

            {active === 'people' ? (
                <div>
                    {usersLoading && <div>Loading users...</div>}
                    {people.length === 0 ? <div>No people found</div> : (
                        <ul>
                            {people.map(p => (
                                <li key={p.id} style={{ padding: 8, borderBottom: '1px solid #eee' }}>
                                    <Link to={`/profile/${p.id}`}>{p.name || p.displayName}</Link>
                                    <div style={{ fontSize: 12, color: '#666' }}>{p.bio}</div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            ) : (
                <div>
                    {songResults.length === 0 ? <div>No songs found</div> : (
                        <ul>
                            {songResults.map(s => {
                                const targetUid = s.userId || s.user || s.artistId || s.userRef || s.ownerId || s.uid || s.id || '';
                                return (
                                    <li key={s.id} style={{ padding: 8, borderBottom: '1px solid #eee' }}>
                                        {targetUid ? (
                                            <Link to={`/profile/${targetUid}`}>{s.title}</Link>
                                        ) : (
                                            <span>{s.title}</span>
                                        )}
                                        <div style={{ fontSize: 12, color: '#666' }}>By {targetUid || 'Unknown'}</div>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
};

export default SearchResultsPage;
